




































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import dataStore from "@/store";
import AccountStore from "@/modules/account/store";
import FileStorageStore from "@/modules/file-storage/store";

import MessagesHistoryItem from "./MessagesHistory/Item.vue";

import MessagingStore from "../store";
import Message from "../message.model";

@Component({
  components: {
    LoadingSpinner,
    MessagesHistoryItem,
  },
})
export default class MessagesHistory extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  private fIsLoading = true;

  private fAccountDataStore: AccountStore;
  private fFileStorageDataStore: FileStorageStore;
  private fMessagingDataStore: MessagingStore;

  private fAnimatingElementsCount = 0;

  get isAnimating(): boolean {
    return this.fAnimatingElementsCount > 0;
  }

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get messages(): Message[] {
    return this.fMessagingDataStore.getMessagesByPlushieId(this.plushieId);
  }

  constructor() {
    super();
    this.fAccountDataStore = getModule(AccountStore, dataStore);
    this.fFileStorageDataStore = getModule(FileStorageStore, dataStore);
    this.fMessagingDataStore = getModule(MessagingStore, dataStore);
  }

  public onAnimationEnd() {
    this.$nextTick(() => {
      this.fAnimatingElementsCount--;
    });
  }

  public onAnimationStart() {
    this.$nextTick(() => {
      this.fAnimatingElementsCount++;
    });
  }

  private async getPlushieData(plushieId: string): Promise<void> {
    const messages = await this.fMessagingDataStore.loadMessagesByPlushieId({
      plushieId: plushieId,
      useCache: false,
    });

    if (messages.length < 1) {
      return;
    }

    const messageIds = messages.map((message) => message.id);

    await this.fMessagingDataStore.loadAttachmentsByMessageIds({
      messageIds: messageIds,
      useCache: true,
    });

    const userIds: string[] = [];
    const storageItemIds: string[] = [];

    messages.forEach((message) => {
      const attachments = this.fMessagingDataStore.getAttachmentsByMessageId(
        message.id
      );

      storageItemIds.push(
        ...attachments.map((attachment) => attachment.storageItem)
      );

      if (!userIds.includes(message.sender)) {
        userIds.push(message.sender);
      }
    });

    await Promise.all([
      this.fAccountDataStore.loadUserInfosByIds(userIds),
      this.fFileStorageDataStore.loadItemsByIds(storageItemIds),
    ]);
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    if (!this.plushieId) {
      return;
    }

    this.fIsLoading = true;

    await this.getPlushieData(this.plushieId);
    this.fIsLoading = false;
  }
}
